<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Hf3YiG/tc-custom/9781504064972.jpg?1705029190878" alt="This image is the cover for the book Oz Series Volume Two, The Oz Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oz Series Volume Two, The Oz Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Dorothy’s adventures in Oz continue in books four through six of the classic children’s fantasy series.</b></p><p><i>Dorothy and the Wizard in Oz</i>: When an earthquake swallows Dorothy and her kitten, Eureka, they’re captured by the Mangaboo people. The Wizard of Oz must save them by winning a magic contest—using only his wits and nine tiny piglets.</p><p><i>The Road to Oz</i>: Dorothy and Toto are on their way to Princess Ozma’s birthday party when they meet the loveable Shaggy Man, but as they try to help him with directions, they wind up getting lost themselves!</p><i>The Emerald City of Oz</i>: When Dorothy learns that Aunt Em and Uncle Henry are in danger of losing their farm, she makes arrangements with Princess Ozma to bring her family to Oz. But while the Wonderful Wizard takes them on a fabulous tour of their new home, the jealous Nome King Roquat plots to conquer the land.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        L. Frank Baum
      </h2>
      
      <p class="authorDescription body article">L. Frank Baum (1856&ndash;1919) was born in upstate New York and began writing stories at a very young age. Best known as the author of the beloved children&rsquo;s classic <I>The Wonderful Wizard of Oz</I>, he wrote thirteen sequels set in the Land of Oz and numerous other novels, poems, and plays.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75337f83